/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
var separator = css({
  background: "var(--ds-border, #091E4224)",
  width: '1px',
  height: '20px',
  margin: "0 ".concat("var(--ds-space-050, 4px)"),
  alignSelf: 'center'
});
var separatorNew = css({
  background: "var(--ds-border, #091E4224)",
  width: '1px',
  height: '20px',
  alignSelf: 'center'
});
var separatorFullHeight = css({
  height: '40px'
});
export default (function (_ref) {
  var fullHeight = _ref.fullHeight;
  return jsx("div", {
    css: [editorExperiment('platform_editor_controls', 'variant1') ? separatorNew : separator, fullHeight && separatorFullHeight]
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "separator"
  });
});